var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { SvgIcon } from '../svg-icon';
export var LayoutCenterIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, rootProps = __rest(_a, ["color"]);
    return (React.createElement(SvgIcon, __assign({ viewBox: "0 0 16 16" }, rootProps),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 2.5H14.5V13.5H1.5V2.5ZM0 15V1H16V15H0ZM6.5 5C6.22386 5 6 5.22386 6 5.5V10.5C6 10.7761 6.22386 11 6.5 11H9.5C9.77614 11 10 10.7761 10 10.5V5.5C10 5.22386 9.77614 5 9.5 5H6.5Z", fill: color })));
};
